module.exports = __webpack_public_path__ + "static/media/mbhsML-large.a12d87aa.png";